var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-dfb157de-3d9f-4790-bc37-4d1035ee6d83",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-93e7aff6-c7a9-4023-bfc4-54526fb7eacb {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-93e7aff6-c7a9-4023-bfc4-54526fb7eacb",
    d: "M20.34,13.2h-8.69c-.29,0-.57.13-.76.35-.19.22-.27.51-.23.8l1.13,7.67c.07.49.49.85.99.85h6.44c.5,0,.92-.36.99-.85l1.13-7.67c.04-.29-.04-.58-.23-.8-.19-.22-.47-.35-.76-.35ZM18.35,20.87h-4.71l-.83-5.67h6.38l-.83,5.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-93e7aff6-c7a9-4023-bfc4-54526fb7eacb",
    d: "M11.35,11.69h9.3c.41,0,.75-.34.75-.75s-.34-.75-.75-.75h-2.92c-.09-.59-.58-1.06-1.2-1.06h-1.08c-.59,0-1.07.43-1.18,1.06h-2.93c-.41,0-.75.34-.75.75s.34.75.75.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.bf25d2184e9349d658f5553fe4b3baec.svg";
export { ForwardRef as ReactComponent };